import * as React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import { Theme } from '@material-ui/core';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';

export interface TransactionPageViewProps {
    returnTransactionId: string;
    returnTransactionStatus: boolean;
    paymentStatus: string;
    payuid: string;
    txnamt: string;
    axperror: string;
    goBack(location: string): void;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            height: 'calc(100vh - 18vh)',
            backgroundColor: '#fff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            boxShadow: '0px 3px 3px -2px rgba(0,0,0,0.2), 0px 3px 4px 0px rgba(0,0,0,0.14), 0px 1px 8px 0px rgba(0,0,0,0.12)'
        },
        innerText: {
            // backgroundColor: '#50D6D9',
            // height: '100vh'
        },
        center: {
            // height: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column'
        },
        center_back: {
            // height: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            margin: theme.spacing(3)
        },
        image: {
            maxHeight: '30vh'
        },
        text: {
            fontWeight: 300,
            color: '#424242',
            textAlign: 'center'
        },
        paragraph: {
            color: '#424242',
            // textAlign: 'center'
            float: 'left'
        },
        right: {
            float: 'right'
        }
    })
);

const TransactionPageView: React.StatelessComponent<TransactionPageViewProps> = props => {
    const classes = useStyles({});

    const renderview = (status: boolean, axperror: string) => {
        if (status === true && axperror === '') {
            return (
                <div className={classes.center}>
                    <img src="/assets/svg/checkmark.svg" alt="Success page" className={classes.image} />
                    <Typography variant="h3" gutterBottom className={classes.text}>
                        Transaction Successful!
                    </Typography>
                    <div className={classes.center}>
                        <Grid container spacing={2} justify="center" alignItems="center">
                            <Grid item xs={12} sm={6}>
                                <Typography variant="body2" gutterBottom className={classes.right}>
                                    Transaction ID :
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="body2" gutterBottom className={classes.paragraph}>
                                    <strong>{props.payuid}</strong>
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="body2" gutterBottom className={classes.right}>
                                    Transaction Status :
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="body2" gutterBottom className={classes.paragraph}>
                                    <strong>{props.paymentStatus}</strong>
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="body2" gutterBottom className={classes.right}>
                                    Transaction Amount :
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="body2" gutterBottom className={classes.paragraph}>
                                    <strong>&#36; {props.txnamt}</strong>
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="body2" gutterBottom className={classes.right}>
                                    EasyConnect Ref No :
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="body2" gutterBottom className={classes.paragraph}>
                                    <strong>{props.returnTransactionId}</strong>
                                </Typography>
                            </Grid>
                        </Grid>
                    </div>
                </div>
            );
        } else if (status === false && axperror === '') {
            return (
                <div className={classes.center}>
                    <img src="/assets/svg/cancel.svg" alt="Success page" className={classes.image} />
                    <Typography variant="h3" gutterBottom className={classes.text}>
                        Transaction Failed!
                    </Typography>
                    <div className={classes.center}>
                        <Grid container spacing={2} justify="center" alignItems="center">
                            <Grid item xs={12} sm={6}>
                                <Typography variant="body2" gutterBottom className={classes.right}>
                                    Transaction ID :
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="body2" gutterBottom className={classes.paragraph}>
                                    <strong>{props.payuid}</strong>
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="body2" gutterBottom className={classes.right}>
                                    Transaction Status :
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="body2" gutterBottom className={classes.paragraph}>
                                    <strong>{props.paymentStatus}</strong>
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="body2" gutterBottom className={classes.right}>
                                    Transaction Amount :
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="body2" gutterBottom className={classes.paragraph}>
                                    <strong>&#36; {props.txnamt}</strong>
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="body2" gutterBottom className={classes.right}>
                                    EasyConnect Ref No :
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="body2" gutterBottom className={classes.paragraph}>
                                    <strong>{props.returnTransactionId}</strong>
                                </Typography>
                            </Grid>
                        </Grid>
                    </div>
                </div>
            );
        }
        return (
            <div className={classes.center}>
                <img src="/assets/svg/cancel.svg" alt="Success page" className={classes.image} />
                <Typography variant="h3" gutterBottom className={classes.text}>
                    Oops! Something went wrong
                </Typography>
                <div className={classes.center}>
                    <Grid container spacing={2} justify="center" alignItems="center">
                        <Grid item xs={6} sm={12} md={12}>
                            <Typography variant="body2" gutterBottom className={classes.right}>
                                contact Easy Connect team <strong>{`<support@mylabconnect.com>`}</strong>
                            </Typography>
                        </Grid>
                    </Grid>
                </div>
            </div>
        );
    };

    return (
        <div className={classes.root}>
            <CssBaseline />
            <Container fixed>
                <div className={classes.innerText}>
                    {
                        renderview(props.returnTransactionStatus, props.axperror)
                    }
                    <div className={classes.center_back}>
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={() => props.goBack('payment')}
                        >
                            GO BACK TO INVOICES
                        </Button>
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={() => props.goBack('home')}
                        >
                            GO HOME
                        </Button>
                    </div>
                </div>
            </Container>
        </div>
    );
};

export default TransactionPageView;



// WEBPACK FOOTER //
// ./src/components/layouts/TransactionPageView.tsx